<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
      label-width="130px"
      label-position="left"
    >
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_quotedSampleName') || '产品报价名称'"
          prop="quotedSampleName"
        >
          <el-input
            v-model="formData.quotedSampleName"
            :placeholder="$l('form_placeholder_quotedSampleName')"
            type="text"
            :maxlength="200"
            show-word-limit
            clearable
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_displayFabric') || '产品报价面料'"
          prop="fabric"
          ref="faceFabricForm"
        >
          <SampleFabric
            :isFabricPosition.sync="formData.isFabricPosition"
            :fabric.sync="formData.fabric"
            :faceFabric.sync="formData.faceFabric"
            :backFabric.sync="formData.backFabric"
            :innerFabric.sync="formData.innerFabric"
            @change="() => $refs.faceFabricForm.clearValidate()"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_quotedMethod') || '报价方式'"
          prop="quotedMethod"
        >
          <dict-select
            v-model="formData.quotedMethod"
            url="/sys/common/dict/system"
            :body="{ dictType: 'quotedMethod' }"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            size="mini"
          />
        </el-form-item>
        <el-form-item :label="$l('form_label_currency') || '货币单位'">
          <dict-select
            class="no-error"
            v-model="formData.currencyUnit"
            url="/master/common/dict/biz"
            :body="{ dictType: 'currencyUnit' }"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            size="mini"
          />
        </el-form-item>
      </div>
    </el-form>
    <div>
      <GoodsSpecTable ref="goodsSpecTable" :tskQuotedGoodsCode="quotedInfo.tskQuotedGoodsCode" :disabled="disabled"></GoodsSpecTable>
    </div>
  </div>
</template>
<script>
import SampleFabric from './sample-fabric'
import GoodsSpecTable from './goods-spec-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { SampleFabric, GoodsSpecTable },
  props: {
    quotedInfo: { type: Object, default: () => {} },
     disabled: { type: Boolean, default: false },
  },
  watch: {
    quotedInfo: {
      handler(val) {
        this.formData = { ...val }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formData: {},
      rules:{}
    }
  },
  methods: {
    async getData() {
      this.$refs.goodsSpecTable.loadData()
    },
    async save() {
      const specData = this.$refs.goodsSpecTable.getTableData()
      const saveParams = {
        ...this.formData,
        specList: specData
      }
      console.log(saveParams)
      this.loadingOpen()
      const res = await this.$api
        .personalTskQuotedGoodsUpdateQuotedApi(saveParams)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.$refs.goodsSpecTable.loadData()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-form {
    .el-form-row {
      display: flex;
      border: 1px solid #ebeef5;
      border-top: none;
      border-left: none;
      .el-form-item {
        margin: 0 !important;
        position: relative;
        width: 100%;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
        }

        .el-form-item__content {
          padding: 0 5px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;
          > div {
            margin: 3.2px 0;
          }
          > .el-input {
            input[readonly] {
              border: none;
              background-color: #fff;
              color: #606266;
              cursor: auto;
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
          .no-error {
            .el-input__inner {
              border-color: #dcdfe6 !important;
            }
          }
        }
      }
    }

    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
  }
}
</style>
